import classNames from "classnames";
import config from "config";
import { useViaduckEnabled } from "duck/api/hooks";
import ChatContainer from "duck/ui/chat/ChatContainer";
import { useDuckFullscreen } from "duck/ui/chat/hooks/useDuckFullscreen";
import InstanceManagementSidebarNav from "instanceManagement/SidebarNav";

import { useCustomLocalStorageState } from "shared/hooks";

import ErrorBoundary from "features/layout/ErrorBoundary";
import AppSidebarNav from "features/layout/SidebarNav";

import { RouteConfig } from "services/routesConfig";

import {
  CONTENT_CLASSES_WITH_TOP_HEADER,
  DEFAULT_EXPANDED_SIDE_NAV,
  SIDEBAR_EXPANDED_KEY,
} from "./constants";
import TopHeader from "./TopHeader";

interface AppLayoutProps {
  children: React.ReactElement;
  routeConfig: RouteConfig;
}

const AppLayout = ({ children, routeConfig }: AppLayoutProps) => {
  const [expanded, setExpanded] = useCustomLocalStorageState<boolean>(
    SIDEBAR_EXPANDED_KEY,
    { defaultValue: DEFAULT_EXPANDED_SIDE_NAV }
  );

  const isViaDuckEnabled = useViaduckEnabled();
  const { isFullscreen } = useDuckFullscreen();
  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  const SidebarNav = config.isInstanceManagement()
    ? InstanceManagementSidebarNav
    : AppSidebarNav;

  const showDuck = !config.isInstanceManagement() && isViaDuckEnabled;
  const fullScreenDuck = showDuck && isFullscreen;

  return (
    <div className="flex flex-row w-full min-w-0 h-[100dvh]">
      <SidebarNav
        expanded={expanded}
        setExpanded={setExpanded}
        toggleExpand={toggleExpand}
        routeConfig={routeConfig}
      />
      <ErrorBoundary>
        <div className={classNames("flex flex-col h-full flex-1 min-w-0")}>
          {!config.isInstanceManagement() && (
            <TopHeader
              sidebarExpanded={expanded}
              routeActions={routeConfig.routeActions}
            />
          )}
          <div className={classNames("flex-1 min-h-0 flex flex-row")}>
            <div
              className={classNames(
                "flex-1 min-w-0  overflow-auto",
                routeConfig.noPadding ? "" : CONTENT_CLASSES_WITH_TOP_HEADER,
                { hidden: fullScreenDuck }
              )}
            >
              {children}
            </div>

            {showDuck && <ChatContainer fullScreen={fullScreenDuck} />}
          </div>
        </div>
      </ErrorBoundary>
    </div>
  );
};

export default AppLayout;
